import { render, staticRenderFns } from "./Notebook.vue?vue&type=template&id=528675bb&scoped=true&"
import script from "./Notebook.vue?vue&type=script&lang=ts&"
export * from "./Notebook.vue?vue&type=script&lang=ts&"
import style0 from "./Notebook.vue?vue&type=style&index=0&id=528675bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528675bb",
  null
  
)

export default component.exports